<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout column justify-center>
        <!-- <v-card v-for="(lesson, index) in $store.state.lessons" class="ma-5 py-3 rounded-card">
          <v-card-title primary-title class="headline">{{lesson.title}}</v-card-title>
          <v-card-text>
            <ul>
              <li v-for="w in $store.getters.getVocabByLesson(index)">{{w.emiWord}}</li>
            </ul>
          </v-card-text>
        </v-card> -->

        <div v-for="(lesson, index) in $store.state.lessons" class="rounded-card text-center">
          <v-card>
            <v-card-title class="headline text-center">{{lesson.title}}</v-card-title>
          </v-card>
          <v-container fluid>
            <v-card v-for="w in $store.getters.getVocabByLesson(index)"
            class="columns ma-2 py-1 rounded-card">
              <v-card-title class="headline text-center" 
              style="padding-left: 0px;
                    padding-right: 0px;">
                <span class="wordTitle"><router-link :to="'Vocab/' + w.emiWord">{{w.emiWord}}</router-link></span>
                <v-card-text class="cardfill">
                  <span> {{w.translations[0].translation}} </span>
                  <!-- <span v-for="(t,i_t) in w.translations">
                    {{i_t + 1}}. {{t.translation}}
                    <span v-if="i_t + 1 < w.translations.length">
                      <br/>
                    </span>
                  </span> -->
                  <div>
                    {{genders[w.gender - 1]}}
                  </div>
                  <div>
                    {{partsOfSpeech[w.partOfSpeech - 1]}}
                  </div>
                </v-card-text>
              </v-card-title>
            </v-card>
          </v-container>
        </div>

        <v-spacer></v-spacer>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
export default {
  name: "Vocabulary",
  data() {
    return {
      partsOfSpeech: [
        "noun", "adjective", "verb", "adverb", "article", "preposition"
      ],
      genders: [
        "masculine", "feminine", "masculine-feminine", "none"
      ]

    };
  }
};
</script>


<style>
li{
  list-style:circle ;
}
.rounded-card {
  border-radius: 10px;
}
.columns {
  display: flex;
  float: left;
  width: 40%;
  height: 300px;
}
.headline {
  text-align: center;
  margin: 0 auto;
}
.wordTitle {
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}
.cardfill {
  font-size: 20px;
  text-align: center;
}
</style>
